"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var store_sdk_1 = require("@subhubapps/store-sdk");
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_1 = __importStar(require("react"));
var google_optimize_1 = require("../../utils/google-optimize");
// the name of the cookie to store the close clicks
var cookieName = 'announcement-bar';
// how many days should the cookie exist?
var cookieExpiration = 7;
// what "data-" els need to be modified for CSS purposes
var relatedClasses = ['announcement-bar-top', 'announcement-bar-height'];
// this class needs to get added to the body when the bar is visible
var bodyClassName = 'announcement-bar-active';
var BANNER_EXPERIMENT_COOKIE_NAME = 'banner_experiment';
var getEls = function (query) { return Array.from(document.querySelectorAll(query)); };
var AnnouncementBarApp = function () {
    var subhubAccountUuid = window.announcementBarApp.subhubAccountUuid;
    var _a = __read((0, react_1.useState)(null), 2), bannerSettings = _a[0], setBannerSettings = _a[1];
    var experimentVariantId = (0, google_optimize_1.useExperiment)(window.announcementBarApp.optimizeExperimentId);
    // shopify will render all banner settings into a window object, so we'll select which one to show here
    var changeBanner = function (path, bundleType) {
        var block = window.announcementBarApp.blocks.find(function (block) { return path.includes(block.path) && (!bundleType || bundleType === block.bundleType); });
        if (!block)
            return false;
        setBannerSettings({
            text: block.text,
            textHex: block.textHex,
            bgHex: block.bgHex,
            imageSrc: block.imageSrc,
        });
        return true;
    };
    function getSubhubBannerDetails() {
        return __awaiter(this, void 0, void 0, function () {
            var dynamicBanner, bannerDetails, bannerData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!subhubAccountUuid)
                            return [2 /*return*/];
                        if (window.announcementBarApp.optimizeExperimentId && !js_cookie_1.default.get(BANNER_EXPERIMENT_COOKIE_NAME) && experimentVariantId === '0')
                            return [2 /*return*/];
                        dynamicBanner = new store_sdk_1.DynamicBanner.BannerManager(subhubAccountUuid);
                        dynamicBanner.extractUrlData(new URL(window.location.href));
                        return [4 /*yield*/, dynamicBanner.getBannerData(window.location.pathname)];
                    case 1:
                        bannerDetails = _a.sent();
                        bannerData = bannerDetails === null || bannerDetails === void 0 ? void 0 : bannerDetails.data;
                        if (bannerData === null || bannerData === void 0 ? void 0 : bannerData.ruleMatched) {
                            return [2 /*return*/, bannerData];
                        }
                        return [2 /*return*/, undefined];
                }
            });
        });
    }
    // call this idempotent method to show the banner
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bannerData, subhubBlock, _loop_1, relatedClasses_1, relatedClasses_1_1, relatedClass;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (js_cookie_1.default.get(cookieName))
                        return [2 /*return*/];
                    return [4 /*yield*/, getSubhubBannerDetails()];
                case 1:
                    bannerData = _b.sent();
                    if (bannerData) {
                        subhubBlock = window.announcementBarApp.blocks.find(function (block) { return block.path === 'subhub'; });
                        setBannerSettings({
                            text: bannerData.text,
                            discountCode: bannerData.discountCode,
                            textHex: bannerData.textColor || (subhubBlock === null || subhubBlock === void 0 ? void 0 : subhubBlock.textHex),
                            bgHex: bannerData.backgroundColor || (subhubBlock === null || subhubBlock === void 0 ? void 0 : subhubBlock.bgHex),
                            imageSrc: subhubBlock === null || subhubBlock === void 0 ? void 0 : subhubBlock.imageSrc,
                        });
                    }
                    else {
                        changeBanner(window.location.pathname);
                    }
                    document.body.classList.add(bodyClassName);
                    _loop_1 = function (relatedClass) {
                        getEls("[data-".concat(relatedClass, "]")).forEach(function (el) { return el.classList.add(relatedClass); });
                    };
                    try {
                        for (relatedClasses_1 = __values(relatedClasses), relatedClasses_1_1 = relatedClasses_1.next(); !relatedClasses_1_1.done; relatedClasses_1_1 = relatedClasses_1.next()) {
                            relatedClass = relatedClasses_1_1.value;
                            _loop_1(relatedClass);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (relatedClasses_1_1 && !relatedClasses_1_1.done && (_a = relatedClasses_1.return)) _a.call(relatedClasses_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // call this idempotent method to hide the banner
    var kill = function () {
        var e_2, _a;
        document.body.classList.remove(bodyClassName);
        var _loop_2 = function (relatedClass) {
            getEls("[data-".concat(relatedClass, "]")).forEach(function (el) { return el.classList.remove(relatedClass); });
        };
        try {
            for (var relatedClasses_2 = __values(relatedClasses), relatedClasses_2_1 = relatedClasses_2.next(); !relatedClasses_2_1.done; relatedClasses_2_1 = relatedClasses_2.next()) {
                var relatedClass = relatedClasses_2_1.value;
                _loop_2(relatedClass);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (relatedClasses_2_1 && !relatedClasses_2_1.done && (_a = relatedClasses_2.return)) _a.call(relatedClasses_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        js_cookie_1.default.set(cookieName, '1', { expires: cookieExpiration });
    };
    // init the banner once and allow for changing banners outside of the react app
    (0, react_1.useEffect)(function () {
        // don't initialize the banner on specific pages that have 'hideAnnouncementBanner' set as window var
        if (window.announcementBarApp.hideAnnouncementBanner)
            return;
        window.announcementBarApp.changeBanner = changeBanner;
        // If there is no experiment, or the experiment is active, initialize the banner (this should render the original CMS banners)
        // If there is an experiment, then check to see if optimize has returned a variant id
        if (!window.announcementBarApp.optimizeExperimentId || (window.announcementBarApp.optimizeExperimentId && experimentVariantId)) {
            console.debug("Optimize experiment ".concat(window.announcementBarApp.optimizeExperimentId, " returned variant ").concat(experimentVariantId));
            if (experimentVariantId === '1') {
                js_cookie_1.default.set(BANNER_EXPERIMENT_COOKIE_NAME, '1', { path: '/' });
            }
            init();
        }
    }, [window.announcementBarApp.optimizeExperimentId, experimentVariantId]);
    return (react_1.default.createElement("div", { id: 'announcement-bar', className: 'announcement-bar-height bg-koromiko position-fixed top-0 right-0 left-0 z100', style: { display: 'none', backgroundColor: bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.bgHex } },
        react_1.default.createElement("div", { className: 'grid-container height-100' },
            react_1.default.createElement("div", { className: 'grid-x align-middle height-100' },
                (bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.imageSrc) && (react_1.default.createElement("div", { className: 'cell image-cell' },
                    react_1.default.createElement("img", { alt: '', src: bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.imageSrc }))),
                react_1.default.createElement("div", { className: 'cell auto padding-horizontal-3 medium-padding-horizontal-6 margin-horizontal-auto font-lighter large-text-center', style: { color: bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.textHex, maxWidth: '900px' } },
                    react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: (bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.text) || '' } })),
                react_1.default.createElement("div", { className: 'cell close-cell' },
                    react_1.default.createElement("a", { className: 'close padding-2 h4 display-inline-block', href: '#', onClick: function () { return kill(); } },
                        react_1.default.createElement("i", { className: 'ss-delete text-white' })))))));
};
exports.default = AnnouncementBarApp;
